import type { QueryClient } from '@tanstack/react-query';
import type { CrawlJob, WithResourceId } from '../../../types/knowledge';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';
import { invalidateKnowledgeDatabaseSummaries } from '../knowledgeQueryInvalidation';

export function invalidateCrawlRelatedQueries(
  queryClient: QueryClient,
  databaseId: string,
  options?: { includeCrawlList?: boolean },
) {
  if (options?.includeCrawlList) {
    void queryClient.invalidateQueries({
      queryKey: knowledgeQueryKeys.crawls(databaseId),
    });
  }
  void queryClient.invalidateQueries({
    queryKey: knowledgeQueryKeys.crawlSchedules(databaseId),
  });
  void queryClient.invalidateQueries({
    queryKey: [...knowledgeQueryKeys.all, 'crawlJobStatus'],
  });
  void queryClient.invalidateQueries({
    queryKey: knowledgeQueryKeys.documentsRoot(databaseId),
  });
  invalidateKnowledgeDatabaseSummaries(queryClient, databaseId);
}

export function upsertCrawlInCache(
  queryClient: QueryClient,
  databaseId: string,
  crawl: WithResourceId<CrawlJob>,
) {
  queryClient.setQueryData<Array<WithResourceId<CrawlJob>>>(
    knowledgeQueryKeys.crawls(databaseId),
    (current) => {
      if (!current) {
        return [crawl];
      }

      const withoutExisting = current.filter(
        (existing) => existing.id !== crawl.id,
      );
      return [crawl, ...withoutExisting];
    },
  );
}

export function normalizeCrawlAfterStartingSelection(
  crawl: WithResourceId<CrawlJob>,
): WithResourceId<CrawlJob> {
  if (crawl.status === 'AWAITING_SELECTION') {
    return { ...crawl, status: 'CRAWLING' };
  }

  return crawl;
}
